import { createSlotRecipe } from './runtime';

const statusDotConfig = {"name":"statusDot","className":"status-dot","slots":["root","dot","label"],"defaultVariants":{"tone":"ok"},"variantMap":{"tone":["accent","deny","muted","ok","warn"]}}

export const statusDot = /* @__PURE__ */ createSlotRecipe(statusDotConfig)